<template>

    <div style="text-align: center; " class="container-fluid">

        <img style="" src="/images/vars_logo.png" alt="VARS Technology" class="auth-logo" />
        <h1 style="">Welcome to VARS Technology!</h1>


    </div>

</template>

<style scoped>
.auth-logo {
    height: 200px;
    margin-top: 18%;
    margin-bottom: 10px;

}

</style>